
















































import { Component, Vue } from 'vue-property-decorator';
import { Order } from '@/models/Order';
import { OrderType } from '@/constants/OrderType';
import { ContractService } from '@/services/ContractService';
import { StateManager } from '@/services/StateManager';
import { Request } from '@/models/Request';
import { RequestType } from '../constants/RequestType';
import { parseUnits, bigNumberify } from 'ethers/utils';
import * as Helper from '@/helpers/Utils';

@Component<PlaceOrder>({
  mounted() {
    ContractService.UpdateBalance();
  },
})
export default class PlaceOrder extends Vue {
  private ratio: number = this.minimumPrice;
  private unit: string = 'wei';
  private amount: number = 1;
  private isBuyOrder: string = 'buy';
  private isMarketPrice: string = '';
  private isLoading: boolean = false;

  private state = StateManager.GetInstance().GetState();

  get minimumPrice(): number {
    return Helper.Utils.ComputeMinimumPrice();
  }

  get orderTitle(): string {
    if (!this.isMarketPrice) {
      return 'Place fixed price order';
    } else {
      return 'Place market price order';
    }
  }

  get error(): string | undefined {
    let error;
    if (this.amount < 0.0001) {
      error = 'ERROR: Minimum number of FC is 0.0001';
    } else if (!this.isMarketPrice) {
      const value = parseUnits(this.ratio.toString(), this.unit);
      if (value.lt(this.minimumPrice)) {
        error = 'ERROR: Minimum price per FC is 10000 wei';
      }
    }

    return error;
  }

  get disclaimerText(): string {
    if (this.error !== undefined) {
      return this.error;
    }

    if (!this.isMarketPrice) {
      return `Your order: I want to ${
        this.isBuyOrder ? 'buy' : 'sell'
        } ${this.amount}x FC for ${this.ratio} ${this.unit} per FC`;
    } else {
      return `Your order: I want to ${
        this.isBuyOrder ? 'buy' : 'sell'
        } ${this.amount}x FC at the best current market price`;
    }
  }

  get balance(): string {
    return (this.state.selfBalance.toNumber() / Math.pow(10, Helper.Utils.TOKEN_DECIMALS)).toString();
  }

  public submitOrder() {
    const request = new Request(
      this.isBuyOrder ? OrderType.BUY : OrderType.SELL,
      this.isMarketPrice ? RequestType.MARKET : RequestType.REGULAR,
      bigNumberify(this.amount.toString()).mul(this.minimumPrice),
      parseUnits(this.ratio.toString(), this.unit).div(this.minimumPrice),
    );

    this.isLoading = true;
    ContractService.PlaceOrderRequest(request)
      .catch((ex) => {
        // tslint:disable-next-line:no-console
        console.log(ex);
        Helper.Utils.LogText('Order failed');
      })
      .finally(() => {
        ContractService.UpdateBalance();
        this.isLoading = false;
      });
  }
}
